<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-email-confirmation">
      <p class="title title-double-line">手続中<span class="mini">-&nbsp;塔経市帝電子異界接続許可情報変更届&nbsp;-</span></p>
      <div class="content content-center">
        <PuffLoadingImage class="waiting-loader" stroke="#BB9A66" />
        <p>しばらくお待ち下さい。</p>
      </div>
    </div>
  </section>
</template>

<script>
import PuffLoadingImage from '@/views/Registration/Images/puff.svg?inlineN'

import FrontPageMixins from '@/mixins/FrontPageMixins'

import {UserEmailConfirmation}  from '@/graphql/mutations/User.graphql'
import {GetMe}  from '@/graphql/queries/User.graphql'

export default {
  mixins : [
    FrontPageMixins
  ],

  components : {
    PuffLoadingImage,
  },

  computed : {
    confirmationToken(){
      return this.$route.params.token;
    }
  },

  data(){
    return {};
  },

  watch : {
    confirmationToken : {
      async handler(token){
        if(token === null) return;

        await this.UXWaiting(4000);
        
        if( await this.executeCheckConfirmation() ){
          await this.$store.dispatch({
            type  : 'message/updateTmpMessage',
            data  : {
              wrap      : false,
              uxWaiting : 800,
              message   : 'CMD:office:changeEmailConfirmationComplete',
            }
          });

          this.$router.push({name : 'office'});
        }
      },
      immediate: true,
      deep: true
    }
  },
  
  methods : {
    executeCheckConfirmation(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UserEmailConfirmation,
          variables : {
            token : this.confirmationToken,
          },
          update    : (store, {data: {me}}) => {
            store.writeQuery({ query: GetMe, data : {
              me : me
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          if(typeof errorSet.first.category !== 'undefined'){
            if(errorSet.first.category === 'validation'){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : errorSet.first.message,
                status      : 'error',
                hasControl  : true,
                autoClose   : false
              }, {root:true});
            }
          }

          await this.UXWaiting(500);

          resolve(false);
        });
      });
    }
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : true
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-registration{
    .pa-email-confirmation{
      
    }
  }
}
</style>